var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlameIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21968 9.0639C7.5968 5.68004 6.66464 1.61136 5.65142 0C13.2506 3.0213 8.99505 12.0852 11.7307 12.9916C13.5545 11.7831 12.9466 10.8767 12.6426 7.85538C20.5458 16.9193 12.3387 23.5661 9.90695 22.9619C11.7307 22.0555 12.6426 18.7321 9.29901 17.5235C5.34745 15.7108 4.43555 15.1065 5.65142 10.2724C-0.731879 17.5235 5.95538 22.0555 6.25935 22.9619C-0.427915 22.3576 -2.25171 13.2937 3.21968 9.0639Z",
    fill: "#AE0824"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlameIco);
export default __webpack_public_path__ + "static/media/flame-ico.542982f61334cc618e5f11bffba33ad5.svg";
export { ForwardRef as ReactComponent };